"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dcSummaryPayloadToFormDataHandler = dcSummaryPayloadToFormDataHandler;
function dcSummaryPayloadToFormDataHandler(data) {
    return {
        visitDate: data.form.visitDate,
        nameOfPersonSpokenTo: data.form.nameOfPersonSpokenTo || "N/A",
        withVisit: data.form.withVisit,
        informedPhysician: data.form.informedPhysician,
        notes: data.form.comments || "",
    };
}
